export const sendClientEvents = (type, reason, source) => {
    const eventData = {
        type,
        group: 'share_on_social_network',
        reason,
        current_page_type: source
    };

    if (typeof Fiverr !== 'undefined' && typeof Fiverr.sendClientEvents === 'function') {
        Fiverr.sendClientEvents(eventData);
    }
};

export default sendClientEvents;



// WEBPACK FOOTER //
// ./src/utils/bigQueryReporter.js